import { useMemo } from 'react';
import { ApiErrorResponse } from '../models';

export function useErrorMessageOnEntityView(
  error: any,
  defaultErrorMessage: string,
) {
  return useMemo(() => {
    if (!error) {
      return '';
    }

    const status = (error as ApiErrorResponse)?.status;

    if (status === 403) {
      return 'Common.errorForbidden';
    }

    if (status === 404) {
      return 'Common.errorNotFound';
    }

    return defaultErrorMessage;
  }, [error, defaultErrorMessage]);
}
